import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ISchoolYear } from '@core/interfaces/ischool-year';
import { LookupService } from '@core/services/lookup.service';
import { tap } from 'rxjs';

@Component({
  selector: 'prism-select-school-year',
  templateUrl: './select-school-year.component.html',
  styleUrl: './select-school-year.component.scss'
})
export class SelectSchoolYearComponent {
  @Output() schoolYear = new EventEmitter<any>();
  @Input() selectedSchoolYear?: number | null;
  @Input() control!: FormControl | any;
  @Input() label: string = 'School Year';
  @Input() required: boolean = false;
  @Input() readOnly?: boolean = false;
  @Input() labelClass: string = '';
  @Input() placeholder: string = 'Select a School Year';
  options: ISchoolYear[] = [];

  constructor(private lookupService: LookupService) {}

  ngOnInit(): void {
    this.getSchoolYear();
  }

  getSchoolYear(): void {
    this.lookupService.getSchoolYears()
        .pipe(
          tap((res: ISchoolYear[]) => this.options = res)
        )
        .subscribe();
  }

  emitYear(schoolYear: any): void {
    this.schoolYear.emit(schoolYear);
  }
}
